<div class="signature-dialog-backdrop" (click)="requestCancel()">
  <section class="signature-dialog" role="dialog" aria-modal="true"
    aria-labelledby="emailSignaturePasteDialogTitle" (click)="$event.stopPropagation()">
    <header class="signature-dialog__header">
      <div class="signature-dialog__title-copy">
        <h2 id="emailSignaturePasteDialogTitle">Paste your signature</h2>
        <p>Copy it in Outlook, then paste it here. Check the preview and save.</p>
      </div>
      <button type="button" class="signature-dialog__close" (click)="requestCancel()"
        aria-label="Close signature editor" tooltip="Close" placement="bottom" container="body" triggers="hover"
        [disabled]="saving">
        <lucide-icon name="x" [size]="18" [strokeWidth]="2"></lucide-icon>
      </button>
    </header>

    <div class="signature-dialog__workspace">
      <div class="signature-dialog__import-pane">
        <div class="signature-dialog__section-heading">
          <strong>Paste from Outlook</strong>
          <span>Your signature is imported as one complete design and cannot be edited here.</span>
        </div>
        <vf-email-signature-editor [value]="value" [pasteOnly]="true"
          ariaLabel="Paste email signature from Outlook"
          (valueChange)="onDraftChange($event)"></vf-email-signature-editor>
        <p class="signature-dialog__notice" role="status" *ngIf="removesSignature">
          Signature cleared. Save to remove it, or paste a new one.
        </p>
        <p class="signature-dialog__error" role="alert" *ngIf="errorMessage">{{ errorMessage }}</p>
      </div>

      <aside class="signature-dialog__preview-pane" aria-label="Email signature preview">
        <div class="signature-dialog__preview-toolbar">
          <strong>Preview</strong>
          <div class="signature-dialog__preview-toggle" role="group" aria-label="Preview size">
            <button type="button" [class.signature-dialog__preview-device--active]="desktopPreviewSelected"
              [attr.aria-pressed]="desktopPreviewSelected" (click)="showDesktopPreview()">
              <lucide-icon name="monitor" [size]="14" [strokeWidth]="2"></lucide-icon>
              Desktop
            </button>
            <button type="button" [class.signature-dialog__preview-device--active]="mobilePreviewSelected"
              [attr.aria-pressed]="mobilePreviewSelected" (click)="showMobilePreview()">
              <lucide-icon name="smartphone" [size]="14" [strokeWidth]="2"></lucide-icon>
              Mobile
            </button>
          </div>
        </div>
        <div class="signature-dialog__preview-canvas">
          <div class="signature-dialog__email-frame"
            [class.signature-dialog__email-frame--mobile]="mobilePreviewSelected">
            <div class="signature-dialog__email-chrome" aria-hidden="true">
              <span></span><span></span><span></span>
            </div>
            <div class="signature-dialog__email-body">
              <p>Hi Alex,</p>
              <p>Thanks for getting in touch. Here’s the information you requested.</p>
              <p>Best,</p>
              <div class="signature-dialog__draft-preview" *ngIf="hasContent">
                <vf-email-signature-preview [html]="previewHtml" label="Signature in an email">
                </vf-email-signature-preview>
              </div>
              <div class="signature-dialog__empty-preview" *ngIf="isEmpty">Your signature will appear here</div>
            </div>
          </div>
        </div>
      </aside>
    </div>

    <footer class="signature-dialog__footer">
      <span class="signature-dialog__footer-note">
        <lucide-icon name="shield-check" [size]="14" [strokeWidth]="2"></lucide-icon>
        Links and unsafe content are checked before saving.
      </span>
      <div class="signature-dialog__footer-actions">
        <button type="button" class="signature-dialog__cancel" (click)="requestCancel()"
          [disabled]="saving">Cancel</button>
        <button type="button" class="signature-dialog__save" (click)="requestSave()" [disabled]="saveDisabled">
          <span *ngIf="!saving">Save signature</span>
          <span *ngIf="saving">Saving…</span>
        </button>
      </div>
    </footer>
  </section>
</div>
